import ReadMore from './ReadMore';

/**
 * До рефакторинга компонента, ReadMore экспортировалось наружу.
 * Возможно где-то на сайтах компонент используется сам по себе.
 * Оставлен для обратной совместимости.
 */
export { default as ReadMore } from './ReadMore';

/**
 * @author Aleksey Dibrivniy <a.dibrivniy@rambler-co.ru>
 */
export default function readMore(block, { title, ...cardsProps }) {
  const content = block?.attributes?.read_more_topics;

  const newContent = content && content.map(topic => {
    return {
      ...topic,
      relationships: {
        image: {
          data: topic.attributes.image,
        },
      },
    };
  });

  return (
    <ReadMore
      title={title}
      content={newContent}
      ids={block?.attributes?.topic_ids}
      include={cardsProps.include}
      singleCard={cardsProps.singleCard}
      feedCard={cardsProps.feedCard}
      drumCard={cardsProps.drumCard}
    />
  );
}
